import React, { useState, useEffect } from "react";
import Navbar from "../Navbar/Navbar";
import Table from "../Table/Table";
import Table_Buttons from "../Table_Button/Table_button";
import { toast } from "react-toastify";
import { API } from "../../Redux/actions/API";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { updateAuth } from "../../Redux/actions/AdminAuthSlice";
import Spinner from "../Spinner/Spinner";

export default function OLDROIIncome(){
    const { userId, jwt_token } = useSelector((state) => state.Auth);
  
    const dispatch = useDispatch();
    const navigate = useNavigate();
  
    const [isLoading, setisLoading] = useState(false);
    const [currentPage, setcurrentPage] = useState(1);
    const [listPerpage, setlistPerpage] = useState(10);
    const [leftreferralApi, setleftreferralApi] = useState([]);
    const [search, setSearch] = useState("");
    const [todate, setTodate] = useState("");
    const [formdate, setFromdate] = useState("");
  
    const [TotalAmount, setTotalAmount] = useState(0);
  
    const referral_API = async () => {
      setisLoading(true);
      try {
        let responceRight = await API?.post(
          "/Adminreport",
          {
            loginid: userId,
            uid: search.slice(2),
            fdate: formdate,
            tdate: todate,
            report: "OLDROIIncome",
            status: "2",
            level: "0",
          },
          {
            headers: {
              Authorization: jwt_token,
            },
          }
        );
  
        setTotalAmount(responceRight?.data?.data[0][0].TotalAmount);
        responceRight = responceRight?.data?.data[0];
        console.log("My_Team", responceRight);
        setleftreferralApi([]);
        let arrayLeft = [];
        responceRight.forEach((item, index) => {
          arrayLeft.push({
            sr: index + 1,
            Uid: `AC${item.uid}`,
            Amount: `$${item.onamount}`,
            Income: `$${item.income}`,
            ActivationDate: item.incomedate
          });
          setleftreferralApi(arrayLeft);
        });
      } catch (e) {
        console.log("error Balance APi", e);
        if (
          e.response.data.showableMessage ==
          "Please login to access this resource"
        ) {
          dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
          sessionStorage.clear();
          localStorage.clear();
          navigate("/");
        }
      } finally {
        setisLoading(false);
      }
    };
  
    useEffect(() => {
      referral_API();
    }, []);
  
    const indexOfLastPost = currentPage * listPerpage;
    const indexOfFirstPage = indexOfLastPost - listPerpage;
    const currentPostleft = leftreferralApi.slice(
      indexOfFirstPage,
      indexOfLastPost
    );
  
    var [my_team, set_my_team] = new useState({
      cols: [
        { Header: "S.No", accessor: "sr" },
        { Header: "User Id", accessor: "Uid" },
        { Header: "Income", accessor: "Income" },
        { Header: "On Amount", accessor: "Amount" },
        { Header: "Date & Time", accessor: "ActivationDate" },
      ],
    });
  
    return (
      <div>
        <Navbar />
        <div class="content-page">
          <div class="content">
            <div class="row">
              <div class="col-md-12">
                <div class="panel panel-primary">
                  <div class="panel-heading">
                    <h4 class="panel-title">Old Trading Bonus </h4>
                  </div>
                  <div class="panel-body">
                    <div class="row">
                      <div class="col-md-3">
                        <input
                          type="text"
                          id="txtuid"
                          ng-model="p.uid"
                          onChange={(e) => setSearch(e.target.value)}
                          class="form-control ng-pristine ng-untouched ng-valid ng-empty ng-valid-maxlength"
                          placeholder="Enter User Id"
                        />
                      </div>
                      <div class="col-md-3">
                        <input
                          class="form-control in-ip-1"
                          onChange={(e) => setFromdate(new Date(e.target.value))}
                          id="fdate"
                          name="fdate"
                          type="date"
                        />
                      </div>
                      <div class="col-md-3">
                        <input
                          class="form-control in-ip-1"
                          onChange={(e) => setTodate(e.target.value)}
                          id="todate"
                          name="todate"
                          type="date"
                        />
                      </div>
                      <div class="col-md-3">
                        <input
                          type="button"
                          id="btnsearch"
                          onClick={() => {
                            referral_API();
                          }}
                          class="btn btn-sm btn-primary"
                          value="Search"
                        />
                      </div>
                    </div>
                    <div class="row">
                      <h4>
                        <span>Total Income: {TotalAmount}</span>
                      </h4>
  
                      {isLoading ? (
                        <Spinner />
                      ) : (
                        <div className="col-md-12">
                          <Table data={currentPostleft} columns={my_team.cols} />
  
                          <Table_Buttons
                            indexOfFirstPage={indexOfFirstPage}
                            indexOfLastPost={indexOfLastPost}
                            setcurrentPage={setcurrentPage}
                            currentPage={currentPage}
                            totalData={leftreferralApi.length}
                            listPerpage={listPerpage}
                            handleRowsPerPageChange={setlistPerpage}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
